<div *ngIf="event">
    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">{{ event.name }}</div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4">Description</div>
            <div class="card-text">
                <strong>Scheduled Start: </strong> {{ event.scheduledTime?.toDate() | date:'yyyy/MM/dd h:mm:ss a'}}<br>
                <strong>Official Start: </strong> <span *ngIf="!event.officialTime"><em>Not Started</em></span>{{ event.officialTime?.toDate() | date:'yyyy/MM/dd h:mm:ss a'}}
            </div>
        </div>
    </div>

    <div *ngIf="(signedIn && event.referees && event.referees.includes(user?.uid)) || (signedIn && event.owner && event.owner==user?.uid)" class="card mb-3">
        <div class="card-body">
            <div class="d-grid gap-3">
                <button (click)="toggleLock()" class="btn btn-lg btn-outline-success">Toggle Lock</button>
                <button (click)="startEvent()" [disabled]="(event)?.officialTime || isLocked()" class="btn btn-lg btn-outline-success">Start</button>

                <button
                    type="button"
                    class="btn btn-lg btn-outline-primary"
                    (click)="collapse.toggle()"
                    [attr.aria-expanded]="!isCollapsed"
                    [disabled]="isLocked()"
                    aria-controls="collapseExample"
                >
                    Show Reset Button
                </button>
                <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                    <div class="d-grid col-6 mx-auto">
                        <button (click)="resetEvent(); isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" [disabled]="isLocked()" class="btn btn-lg btn-outline-warning">Reset</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card mb-3">
        <div class="card-body">
            <div class="card-title h4 d-flex justify-content-between align-items-center">
                Entries
                <span *ngIf="(event?.owner && signedIn && event?.owner==user?.uid) && !isLocked()">
                    <app-entry-create [eventId]="id" [referees]="event?.referees" [redirectOnSuccess]="false"></app-entry-create>
                </span>
            </div>
            <div class="card-text">
                <app-entry-list [entries]="entries" *ngIf="(entries | async)?.length; else noEntries"></app-entry-list>
            </div>
        </div>
    </div>

</div>

<ng-template #noEntries>
    No Entries
</ng-template>